// extracted by mini-css-extract-plugin
module.exports = {"dot":"discover-HeroSliderDot__dot--3RA0h","isActive":"discover-HeroSliderDot__isActive--2D9-L","dotInner":"discover-HeroSliderDot__dotInner--pNJZu"};